<template>
  <div class="pricing-card-line pricing-card-line--custom">
    <span class="pricing-card-line__item"><slot /></span>
    <span class="pricing-card-line__type mr-1"></span>
    <span class="pricing-card-line__value">{{ $t(label || 'customPricingLabel') }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    label: String,
  },
}
</script>
